export const imageCodes = {
    banImage: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fban.jpg?alt=media&token=77fed6ab-cf8d-4ef6-a8d1-821d3420b8f6",
    },

    Mobban: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fban1.jpg?alt=media&token=e788b5e0-c613-485a-90e1-6fd511a8c2fa",
    },

    Product: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fproduct.jpg?alt=media&token=24192fc1-26ff-450d-8ff1-67d749679b92",
    },

    Product1: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fproduct1.jpg?alt=media&token=1be97fda-0a5a-481f-bc62-c81ec4fe2f47",
    },

    Product2: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fphoto4.png?alt=media&token=873c6562-e6e0-436b-a1ab-f1f704e2d132",
    },
    
    Product3: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fphoto7.png?alt=media&token=6437ea3a-5272-4848-8fa5-1f6cb01748ac",
    },

    Product4: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fphoto6.png?alt=media&token=739919b8-4934-4d2d-a478-5f80b6a2e30f",
    },

    Product5: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fen.png?alt=media&token=e7e0bca9-e446-4241-bf82-c82b0a81e7a5",
    },

    Product6: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fen1.png?alt=media&token=49f7c184-53de-4ab2-83c2-805657dfcf80",
    },

    Product7: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fen2%20(1)%201.png?alt=media&token=f9091802-acae-4584-b0d0-c1c9b7822e24",
    },

    Product8: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fen3%20(1)%201.png?alt=media&token=517b1cd5-10c3-49d4-b0e4-5f2473c6b2cc",
    },

    Product9: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fphoto5.png?alt=media&token=8f710ba0-2f5d-4167-a040-0a67bfef01ae",
    },
    
}

export const videoCodes = {
    video1: {
        code: "${merchantId}_tmpl_video_1",
        video: "https://www.youtube.com/embed/MV-9DRoxWAM"
    },

    video2: {
        code: "${merchantId}_tmpl_video_2",
        video: "https://www.youtube.com/embed/ncKvlu9oDR0"
    },

    video3: {
        code: "${merchantId}_tmpl_video_2",
        video: "https://www.youtube.com/embed/z_-TnNnodJo"
    }
}

export const textCodes = {
    text: {
        code: "${merchantId}_tmpl_text_2",
        text: "ENCORE has been established since 2020 by 2 friends who are interested in street and grunge fashion. The type and style of clothing we wanted to wear was not available in our country at the time, so we started to develop and sell it our own."
    },

    shopNow: {
        code: "${merchantId}_tmpl_text_1",
        text: "S H O P N O W"
    },
}

export const titleCodes = {
    title: {
        code: "${merchantId}_tmpl_title_1",
        title: "Photo Gallery"
    },

    title2: {
        code: "${merchantId}_tmpl_title_3",
        title: "ABOUT"
    },

    
}